/**
 * The locales a user can pick, which set their number and date formats — the
 * same list the old UI offers. Codes use the API's underscore form.
 */
export const USER_LOCALES = [
  'ar', 'ar_EG', 'ar_JO', 'my', 'da', 'en', 'en_US', 'en_GB', 'en_CA', 'en_AU', 'en_PH',
  'et', 'fr', 'fi', 'de', 'de_DE', 'de_AT', 'de_CH', 'el', 'in', 'is', 'lt', 'lb', 'ms', 'ms_BN',
  'ms_MY', 'no', 'pl', 'pt', 'pt_BR', 'pt_PT', 'ro', 'ru', 'es', 'es_ES', 'es_AR', 'sv', 'sv_SE',
  'sv_FI', 'th', 'tl', 'tr', 'vi',
]

/** A locale's name in the given display language, e.g. "English (United Kingdom)". */
export function localeLabel(code: string, displayLanguage: string): string {
  try {
    // `in` is the old code for Indonesian, which Intl knows as `id`.
    const tag = code.replace('_', '-').replace(/^in\b/, 'id')
    const name = new Intl.DisplayNames([displayLanguage], { type: 'language' }).of(tag)
    return name ? `${name} (${code})` : code
  } catch {
    return code
  }
}
